<template>
  <v-checkbox
    v-model="dValue"
    :rules="cRules"
    :label="sentence"
    v-bind="$attrs"
  >
    <template #label>
      <p
        class="mb-0"
      >
        {{ sentence }}
      </p>
      <router-link
        :color="'Primary'"
        :to="to"
      >
        {{ routeLabel }}
      </router-link>
    </template>
  </v-checkbox>
</template>
<script>
import i18n from '@/plugins/i18n'
export default {
  props: {
    sentence: {
      type: String,
      default: i18n.t('components.AtTCCheckbox.sentence')
    },
    routeLabel: {
      type: String,
      default: i18n.t('components.AtTCCheckbox.termsAndConditions')
    },
    to: {
      type: [String, Object],
      default: () => {
        return {
          name: 'terms-and-conditions'
        }
      }
    },
    removeDefaultRules: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dValue: false
    }
  },
  computed: {
    cRules () {
      const r = this.$attrs.rules ?? []
      return this.removeDefaultRules
        ? [...r]
        : [
          v => { return !!v || this.$t('components.AtTCCheckbox.rules.must_agree') },
          ...r
        ]
    }
  },
  watch: {
    dValue: {
      handler: function (val) {
        this.$emit('input', val)
      },
      immediate: true
    }
  },
  methods: {
  }
}
</script>
<style scoped>
</style>
